import React, { useRef, useState } from 'react'
import { useRouter } from 'next/router'
import sortBy from 'lodash/sortBy'
import { ENTITY, NFT_TABLE_TYPES, CURRENCY_SELECT_OPTIONS } from 'src/consts'
import { TableView } from 'src/components/TableView'
import { FiltersWrapper } from 'src/elements'
import { NFTFilters } from 'src/pages/NFT/components/NFTFilters'
import { useNFTCollections } from 'src/state/NFTCollections'
import { filteredNFTParams } from 'src/utils'

export const Table = ({ filterVisibility, setFilterVisibility }) => {
  const { query } = useRouter()
  const params = filteredNFTParams(query)
  const { data } = useNFTCollections({ ...params })

  const shortData = data => {
    return sortBy(data || [], [d => d.volume])
      .reverse()
      .map((item, index) => ({
        ...item,
        index: index + 1,
      }))
  }

  const [exceptions, setExceptions] = useState(data?.exceptions || [])
  const [dataFilter, setDataFilter] = useState(shortData(data?.data))

  const displayCurrency = !!params.currency
    ? params.currency
    : CURRENCY_SELECT_OPTIONS[0].children[0].value

  const activePeriod = !!params.period ? params.period : '1h'

  const layoutRef = useRef(null)

  const onPageChange = () => {
    layoutRef.current?.scrollToTop()
  }

  return (
    <div>
      <FiltersWrapper
        filterVisibility={filterVisibility}
        filterToggle={setFilterVisibility}
      >
        <NFTFilters
          displayCurrency={displayCurrency}
          filters={params}
          min={data?.min}
          max={data?.max}
          isTable={true}
          data={dataFilter}
          exceptions={exceptions}
          setExceptions={setExceptions}
          setDataFilter={setDataFilter}
        />
      </FiltersWrapper>
      <TableView
        currency={displayCurrency}
        activePeriod={activePeriod}
        entity={ENTITY.NFT}
        category={ENTITY.NFT}
        tableType={NFT_TABLE_TYPES.DEFAULT}
        onPageChange={onPageChange}
        entitiesData={dataFilter}
      />
    </div>
  )
}
